module.exports = __webpack_public_path__ + "img/mypage09.cbed54af.png";